module.exports = __webpack_public_path__ + "static/media/colebrook.20b5bede.png";